// New admins would otherwise never notice the helper bot behind a sidebar
// badge, so surface the conversation once and let normal read state retire it.
export default {
  name: "open-helper-bot-drawer",

  initialize(owner) {
    const channelId = owner.lookup(
      "service:current-user"
    )?.discourse_helper_bot_channel_id;

    if (!channelId) {
      return;
    }

    const appEvents = owner.lookup("service:app-events");

    const maybeOpen = async () => {
      appEvents.off("page:changed", maybeOpen);

      const site = owner.lookup("service:site");
      const siteSettings = owner.lookup("service:site-settings");
      const chat = owner.lookup("service:chat");
      const chatStateManager = owner.lookup("service:chat-state-manager");

      if (
        !siteSettings.discourse_ai_enabled ||
        site.mobileView ||
        !chat?.userCanChat ||
        chatStateManager.isActive
      ) {
        return;
      }

      const channel = await owner
        .lookup("service:chat-channels-manager")
        .find(channelId);
      const membership = channel?.currentUserMembership;

      if (
        !channel ||
        !membership?.following ||
        membership.muted ||
        membership.lastReadMessageId
      ) {
        return;
      }

      appEvents.trigger("chat:open-url", `/chat/c/-/${channelId}`);
    };

    appEvents.on("page:changed", maybeOpen);
  },
};
